export default {
    hash: '#',
    unauthorized: '/unauthorized',
    forbidden: '/forbidden',
    login: '/login-option',
    company: {
        main: '/dashboard/employee/company',
        update: '/dashboard/employee/company/update-data',
        list: '/dashboard/employee/company/update-data',
    },
    access: {
        list: '/dashboard/employee/access',
    },
    zone: {
        list: '/dashboard/employee/zones',
        update: '/dashboard/employee/zones/update-zone/',
        devices: '/dashboard/employee/zones/show-devices/',
        devicesCreate: '/dashboard/employee/zones/create-device',
        devicesUpdate: '/dashboard/employee/zones/update-device/',
        details: '/dashboard/employee/zones/single-zone-details/',
    },
    devices: {
        list: '/dashboard/employee/devices',
        configuration: '/dashboard/employee/devices/configuration',
        create: '/dashboard/employee/devices/create',
        update: '/dashboard/employee/devices/update/',
    },
    zoneDevice: {
        create: '/dashboard/employee/zones/create-device/',
        update: '/dashboard/employee/zones/update-device/',
    },
    department: {
        list: '/dashboard/employee/departments',
    },
    controller: {
        list: '/dashboard/employee/controller',
        create: '/dashboard/employee/controller/create-controller',
        update: '/dashboard/employee/controller/update/',
        readers: '/dashboard/employee/readers',
        sios: '/dashboard/employee/sios',
        inputs: '/dashboard/employee/inputs',
        outputs: '/dashboard/employee/outputs',
        acrs: '/dashboard/employee/acrs',
    },
    employee: {
        list: '/dashboard/employee/all-employees',
        create: '/dashboard/employee/all-employees/add-employee',
        edit: '/dashboard/employee/all-employees/update-employee/',
        orderDetails: '/dashboard/employee/suppliers/order-details/',//Used
        importErrors: '/dashboard/employee/all-employees/errors',
        userDocuments: '/dashboard/employee/user-documents',
        identityValidation: '/dashboard/employee/all-employees/identity-validation/',
        suppliersIdentityValidation: '/dashboard/employee/suppliers/identity-validation/',//used
        supplierEmployeeDetails:'/dashboard/employee/suppliers/employee-detail/',//Used
        supplierVehicleDetails:'/dashboard/employee/suppliers/vehicle-detail/',//Used
        contractorEmployeeDetails:'/dashboard/employee/contractors/employee-detail/',//Used
        contractorVehicleDetails:'/dashboard/employee/contractors/vehicle-detail/', //Used
        createContract: '/dashboard/employee/contractors/create-contract', //Used
        updateContract: '/dashboard/employee/contractors/update-contract/', //Used
        contractDetails: '/dashboard/employee/contractors/contract-details/', //Used
        documentRequestDetailsContractor: '/dashboard/employee/contractors/document-request-details/',
        documentRequestDetailsSupplier: '/dashboard/employee/suppliers/document-request-details/',//Used
        contractorIdentityValidation: '/dashboard/employee/contractors/identity-validation/',
        details: '/dashboard/employee/contractors/contractor-detail/',
        suppliersDetails: '/dashboard/employee/suppliers/suppliers-detail-page/',//used
        createOrder: '/dashboard/employee/suppliers/create-order', //Used
        updateOrder: '/dashboard/employee/suppliers/update-order/', //Used
    },
    contractor: {
        createEmployee: '/dashboard/contractor/add-new-employe',
        updateEmployee: '/dashboard/contractor/update-employee/',
        identityValidation: '/dashboard/contractor/identity-validation/',
        employeeDetails: '/dashboard/contractor/contractor-employee-detail/',
        list: '/dashboard/employee/contractors',
        contractList: '/dashboard/contractor/contracts',
        restriction: '/dashboard/employee/contractor-restriction',
        searchEmployee: '/dashboard/contractor/search-employe',
        create: '/dashboard/employee/contractors/add-contractor',
        update: '/dashboard/employee/contractors/update-contractor/',
        details: '/dashboard/employee/contractors/contractor-detail/',
        contractDetails: '/dashboard/contractor/contract-details/',
        importErrors: '/dashboard/employee/contractors/errors',
        employeeImportErrors: '/dashboard/contractor/errors-employee',
        listMeals: '/dashboard/contractor/meals',
        basket: '/dashboard/contractor/basket',
        foodie:'/dashboard/contractor/foodie',
        createApprovalLevel:'/dashboard/employee/contractors/create-approval-level',
        updateApprovalLevel:'/dashboard/employee/contractors/update-approval-level/',
        companyDocumentation:'/dashboard/contractor/company-documentation',
        employeeDocumentation:'/dashboard/contractor/employee/company-documentation/',
        vehicleDocumentation:'/dashboard/contractor/vehicle/company-documentation/',

    },
    suppliers: {
        list: '/dashboard/employee/suppliers',
        profile: '/dashboard/supplier/profile',
        employees: '/dashboard/supplier/employees',
        foodie: '/dashboard/supplier/foodie',
        vehicleFleet: '/dashboard/supplier/vehicles',
        orders: '/dashboard/supplier/orders',
        completeOrder: '/dashboard/supplier/complete-order/',
        updateOrder: '/dashboard/supplier/update-order/',
        ordersDetail: '/dashboard/supplier/order-detail/',//Used
        announcements: '/dashboard/supplier/announcements',
        createEmployee: '/dashboard/supplier/create-employee',
        employeeDetails: '/dashboard/supplier/supplier-employee-details/',
        updateEmployee: '/dashboard/supplier/update-employee/',
        identityValidation: '/dashboard/supplier/identity-validation/',
        supplierOrderDetails: '/dashboard/supplier/supplier-order-detail/',//Used
        transportRequest: '/dashboard/supplier/transport-request-panel',//Used
        listMeals: '/dashboard/supplier/meals',//Used
        basket: '/dashboard/supplier/basket',//Used
        main: '/dashboard/employee/suppliers',//Used
        restriction: '/dashboard/employee/supplier-restriction',
        addSuppliers: '/dashboard/employee/suppliers/add-suppliers',

        updateSuppliers: '/dashboard/employee/suppliers/update-suppliers/',
        supplierOrderDetail: '/dashboard/employee/suppliers/supplier-order-detail/',
        importErrors: '/dashboard/employee/suppliers/errors',
        employeeImportErrors: '/dashboard/supplier/errors-employee',
        vehicleImportErrors: '/dashboard/supplier/errors-vehicle',
        createApprovalLevel:'/dashboard/employee/suppliers/create-approval-level',//Used
        updateApprovalLevel:'/dashboard/employee/suppliers/update-approval-level/',//Used
        companyDocumentation:'/dashboard/supplier/company-documentation',//Used
        employeeDocumentation:'/dashboard/supplier/employee/company-documentation/',//Used
        vehicleDocumentation:'/dashboard/supplier/vehicle/company-documentation/',//Used
    },
    restriction: {
        vcardSettings: '/dashboard/employee/vcard-settings',
        userRestriction: '/dashboard/employee/user-restriction',
    },
    headers: {
        headers: '/dashboard/employee/company/headers',
    },
    document: {
        upload: '/dashboard/contractor/employee-upload-documents/',
        restriction: '/dashboard/employee/document-restriction',
        list: '/dashboard/employee/company/document-panel',
    },
    vehicleDocument: {
        upload: '',
        restriction: '/dashboard/employee/document-vehicle-restriction',
        list: '/dashboard/employee/company/vehicle-doc-panel',
    },
    event: {
        upload: '',
        restriction: '/dashboard/employee/event-restriction',
        create: '/dashboard/employee/events/normal-events',
        list: '/dashboard/employee/events/main',
        details: '/dashboard/employee/events/reservation/',
    },
    vehicleFleet: {
        list: '/dashboard/employee/vehicle-fleet',
        create: '/dashboard/employee/vehicle-fleet/create-vehicle',
        update: '/dashboard/employee/vehicle-fleet/update-vehicle/',
        details: '/dashboard/employee/vehicle-fleet/vehicle-detail/',
        importErrors: '/dashboard/employee/vehicle-fleet/errors',
    },
    vehicleContractor: {
        document: '/dashboard/contractor/upload-vehicle-documents/',
        create: '/dashboard/contractor/addvehical',
        update: '/dashboard/contractor/update-vehicle/',
        details: '/dashboard/contractor/contractor-vehicle-detail/',//Used
        details2: '/dashboard/employee/contractors/vehicle-contract-detail/',
        search: '/dashboard/contractor/search-vehicle',
        importErrors: '/dashboard/contractor/errors-vehicle'
    },
    vehicleSupplier: {
        list: '/dashboard/supplier/vehicles',//Used
        create: '/dashboard/supplier/add-vehicles',
        update: '/dashboard/supplier/update-vehicles/',
        details: '/dashboard/supplier/supplier-vehicle-detail/'//Used
    },
    announcement: {
        list: '/dashboard/employee/announcement-panel',
        update: '',
        details: '',
        create: '/dashboard/employee/company/create-announcement',
        supplier: '/dashboard/supplier/announcements',
        contractor: '/dashboard/contractor/announcements',
    },
    visitor: {
        list: '/dashboard/employee/visitor',
        listGuard: '/dashboard/employee/guard/visitor',
        update: '/dashboard/employee/visitor/update',
        details: '',
        create: '',
    },
    visitorType: {
        update: '/dashboard/employee/visitor-type/update/',
        details: '',
        create: '/dashboard/employee/visitor-type/create',
    },
    visitorInvitation: {
        create: '/dashboard/employee/visitor-invitation/create',
        update: '',
        details: '/dashboard/employee/visitor-invitation/invitation-detail',
        public: '/visitor-invitation/visitor-public-detail',
    },
    visitorRequest: {
        main:'/dashboard/employee/visitor-request',
        documentation:'/dashboard/employee/visitor-request/invitation-documentation',
        identity:'/dashboard/employee/visitor-request/invitation-identity'
    },
    cardDesigner: {
        list: '/dashboard/employee/card-designer',
        update: '',
        details: '',
        create: '/dashboard/employee/card-designer/create-template',
    },
    roles: {
        list: '/dashboard/employee/company/roles-panel',
        update: '/dashboard/employee/company/add-update-role/',
        details: '',
        create: '/dashboard/employee/company/add-new-role',
    },
    attendance: {
        list: '/dashboard/employee/attendance',
        update: '',
        details: '',
        manage: '/dashboard/employee/attendance/manage-attendence'
    },
    attendanceShiftAccess: {
        list: '',
        addEdit: '/dashboard/employee/attendance/shift/add-edit/',
    },
    attendanceGeoFence: {
        list: '',
        create: '/dashboard/employee/attendance/geofence/create',
        update: '/dashboard/employee/attendance/geofence/update/',
    },
    foodie: {
        list: '/dashboard/employee/foodie/main'
    },
    foodieCafeteria: {
        list: '',
        update: '/dashboard/employee/foodie/cafeteria/update/',
        details: '',
        create: '/dashboard/employee/foodie/cafeteria/create/',
    },
    foodieIngredient: {
        list: '',
        addEdit: '/dashboard/employee/foodie/ingredient/add-edit/',
        update: '',
        details: '',
    },
    foodieMenu: {
        list: '',
        create: '/dashboard/employee/foodie/menu/create',
        update: '/dashboard/employee/foodie/menu/update/',
        details: '/dashboard/employee/foodie/menu/details/',
        clone: '/dashboard/employee/foodie/menu/clone',
    },
    foodieDish: {
        list: '',
        create: '/dashboard/employee/foodie/dishes/create',
        update: '/dashboard/employee/foodie/dishes/manage/',
        details: '',
    },
    foodieManage: {
        list: '/dashboard/employee/foodie/foodie',
        create: '/dashboard/employee/foodie/manage-foodie',
        manage: '/dashboard/employee/foodie/manage-foodie',
    },
    foodieShift: {
        list: '',
        addEdit: '/dashboard/employee/foodie/shift/add-edit/',
    },
    deliveredServices: {
        list: '/dashboard/employee/delivered-services/main',
    },
    foodieKitchen: {
        list: '/dashboard/employee/kitchen/main',
    },
    distributionCenter: {
        list: '/dashboard/employee/distribution-center-panel',
        create: '',
        update: '',
    },
    workshift: {
        list: '/dashboard/employee/company/workshift-panel',
        create: '',
        update: '',
    },
    onboarding: {
        list: '/dashboard/employee/company/onboarding',
        create: '',
        update: '',
    },
    email: {
        list: '/dashboard/employee/attendance/email-setting',
        create: '',
        update: '',
    },
    backup: {
        list: '/dashboard/employee/backup',
        create: '',
        update: '',
    },
    homeOffice: {
        list: '/dashboard/employee/work-office',
        create: '',
        update: '',
    },
    logPlatform: {
        list: '/dashboard/employee/logs',
        create: '',
        update: '',
    },
    guard: {
        list: '/dashboard/employee/guard',
        incomingInvitation : '/dashboard/employee/incoming-invitation',
        incomingContractors : '/dashboard/employee/incoming-contractors',
        visitor : '/dashboard/employee/guard/visitor',
        create: '',
        update: ''
    },
    hardDelete: {
        list: '/dashboard/employee/hard_delete',
        create: '',
        update: '',
    },
    graphs: {
        list: '/dashboard/employee/graphs',
        create: '',
        update: '',
    },
    cards: {
        list: '/dashboard/employee/cards',
        create: '',
        update: '',
    },
    profile:{
        list:'/dashboard/employee/profile',
        create:'',
        update:'',
        contractor:'/dashboard/contractor/profile',
        supplier:'/dashboard/supplier/profile',
    },
    systemConfig: {
        list: '/dashboard/system-config',
        create: '',
        update: '',
    },
    orders: {
        list: '/dashboard/supplier/orders',
        create: '',
        update: '',
    },
    accessRights: {
        list: '/dashboard/contractor/access-rights',
        create: '',
        update: '',
    },
    serviceType: {
        list: '/dashboard/employee/service-type-panel',
        create: '',
        update: '',
    },
    approval: {
        list: '/dashboard/employee/approval',
        update: '/dashboard/employee/approval/update/',
        details: '',
        create: '/dashboard/employee/approval/create',
    },
    transportRequest: {
        list: '/dashboard/employee/transport-request-panel',
        update: '/dashboard/employee/transport-request-panel/update/',
        details: '',
        create:'/dashboard/employee/transport-request-panel/create'
    },
    foodieOrders: {
        main: '/dashboard/employee/foodie-orders/main',
        listMeals: '/dashboard/employee/foodie-orders/meals',
        basket: '/dashboard/employee/foodie-orders/basket'
    },
    approvalTracker: {
        main : '/dashboard/employee/approval-tracker/',
        details : '/dashboard/employee/approval-tracker/details/',
    },
    invitationDetails : {
        invitation: '/invitation-details/',
        registrationProcess: '/invitation-details/process/',
        identityValidation: '/invitation-details/validation/',
        chooseValidationType:'/invitation-details/choose-validation/',
        createExternal:'/invitation-details/create/',
        currentlyUnderReview: '/invitation-details/under-review/',
        documentationValidation: '/invitation-details/documentation-validation/',
        documentationUnderReview: '/invitation-details/documentation-validation/under-review/',
        createDocumentary: '/invitation-details/create-documentation/',
        successfullyVerified: '/invitation-details/successfully-verified/'
    },
    veridasIntegration : {
        documentPage: '/document-validation/',
        selfieValidation: '/selfie-validation/',
        successValidation: '/success-validation/',
        validationFail: '/validation-fail/'
    },
    docs:{
        dataProcessing: '/docs/data-processing.pdf',
        privacyPolicy:'/docs/privacy-policy.pdf',
        reservationTemplate:'/docs/reservation-template.xlsx'
    },
    qrRequestAccess: {
        qr: 'qr-request-access',
        main: '/qr-request-access',
        findMySelf: '/qr-request-access/find-my-self',
        findMySelfCreateVisitor: '/qr-request-access/find-my-self-create-visitor',
        iAmNewHere: '/qr-request-access/i-am-new-here',
    },
      traffic: {
        list: '/dashboard/employee/traffic',
        update: '',
        details: '/dashboard/employee/traffic/details/',
        create: '',
    },
      geofences: {
        update: '/dashboard/employee/traffic/geofences/update/',
        details: '',
        create: '/dashboard/employee/traffic/geofences/create',
    },
    equipmentAndMaterial: {
        list: '/dashboard/contractor/equipment-and-materials',
        create: '/dashboard/contractor/equipment-and-materials/create',
        update: '/dashboard/contractor/equipment-and-materials/update/',
        details: '/dashboard/contractor/equipment-and-materials/details/',
    },
    eventDetails: {
        qr: 'event-details/',
        main: '/event-details/',
        register: '/event-details/register/',
        findMySelf: '/event-details/register/find-myself/',
        chooseValidationType:'/event-details/choose-validation/',

        documentPage: '/event-details/document-validation/',
        selfieValidation: '/event-details/selfie-validation/',
        successValidation: '/event-details/success-validation/',
        validationFail: '/event-details/validation-fail/',


        successfullyRegistered: '/event-details/register/successfully/',


        findMySelfCreateVisitor: '/event-details/register/find-myself-create-visitor/',
        iAmNewHere: '/event-details/register/i-am-new-here/',
    }
};
